import { CommonModule } from "@angular/common";
import { Component, Input, OnInit, ViewChild, AfterViewInit } from "@angular/core";
import { NgxSpinnerModule, NgxSpinnerService } from "ngx-spinner";
import { LfnUpstreamEquipmentOverwriteComponent } from "../../components/lfn-flow/lfn-upstream-equipment-overwrite/lfn-upstream-equipment-overwrite.component";
import { JlStructureComponent } from "../../components/common/jl-structure/jl-structure.component";
import { TableComponent } from "../../components/common/table/table.component";
import { TitleTextPipe } from "../../custom.pipe";
import { MapHDComponent } from "../map-hd/map-hd.component";
import { MatTableDataSource } from "@angular/material/table";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { ApiService } from "../../api.service";
import { SmpConnectivityHDComponent } from "../smp-connectivity-hd/smp-connectivity-hd.component";
import { SelectBjlHDComponent } from "../select-bjl-hd/select-bjl-hd.component";

@Component({
    selector: "app-select-smp-hd",
    standalone: true,
    imports: [
        TableComponent,
        CommonModule,
        NgxSpinnerModule,
        TitleTextPipe, MapHDComponent, SmpConnectivityHDComponent,
        LfnUpstreamEquipmentOverwriteComponent, JlStructureComponent, SelectBjlHDComponent
    ],
    templateUrl: "./select-smp-hd.component.html",
    styleUrls: ["./select-smp-hd.component.scss"]
})

export class SelectSmpHDComponent implements OnInit {
  
  @Input() inputData : any;
  tableData: any;
  displayedColumns: string[] = [];
  dataSource!: MatTableDataSource<any>;
  showBJLTable: boolean = true;
  isLoading: boolean = false;
  showMessage: boolean = false;
  MessageToShow: any;
  select_jl_screen: boolean = true;
  show_smp_table: boolean = false;
  select_table = true;
  @ViewChild(TableComponent, { static: false })
  tableChildComponent!: TableComponent;
  @ViewChild(MapHDComponent)
  mapChildComponent!: MapHDComponent;
  smp_connectivity_flag: boolean = false;
  
  pit_value : string = "";
  show_status:boolean = false;
  pit_validation:any;
  show_distance = false;
  update_pit:boolean = false;
  pit_size_value : string = "";
  trench_creation:boolean = false;
  no_of_pits:string = '';
  a_pit:string = '';
  z_pit:string = '';
  bjl_flag:boolean = false;

  constructor(private toastr: ToastrService,
    private apiService: ApiService,
    private spinner: NgxSpinnerService,
    private router: Router) { 

  }

  ngAfterViewInit() {
    console.log(this.tableChildComponent); // Should NOT be undefined here
    console.log(this.mapChildComponent); // Should NOT be undefined here
    //this.mapChildComponent.receiveTableEvent(this.inputData);
  }

  ngOnInit() {
    if (this.inputData.message === 'select bjl structure n2p') {
      this.show_smp_table = false;
      this.update_pit = true
    }
  }

  receiveTableEventUpstream(data:any) {
    
 }
 

  OnSelectProceedMap(data: any) {
    //this.inputData['selected_smp_structure'] = data;
    this.isLoading = true;
    this.spinner.show() 
    this.pit_value = ''; 
    if(this.inputData.request_type == "FMB_request"){
        this.apiService.newhdBjl(this.inputData).subscribe({
        next: (response) => {
              if (response.message == 'select bjl n2p') {
                this.select_jl_screen = false;
                this.inputData = response;
                this.tableData = response;
                this.bjl_flag = true;
              }
              else {              
                if ('file_name' in response) {
                  this.showBJLTable = false;
                  this.showMessage = true;
                  this.MessageToShow = response;
                } else {
                  this.toastr.error(response.message, 'Error Message');
                  console.log('error');
                }
              }

              this.isLoading = false;
              this.spinner.hide();
              // window.alert(response.messgae);
        }
        ,
        error: (error) => {
              this.isLoading = false;
              this.spinner.hide();
              this.toastr.error(
                `The API returned Unsuccessfull response : ${error}`,
                'Error Message'
              );
            },
      });
    }
    else {
    this.apiService.selectSmpStructureHD(this.inputData,this.inputData.message).subscribe({
      next: (response) => {
        if (response.message === 'select smp structure') {
              this.showBJLTable = false;
              this.inputData = response;
              this.tableData = response;
              this.select_jl_screen = true;
              this.show_smp_table = true;
              //this.tableChildComponent.initializeFunction(this.inputData);
              this.mapChildComponent.receiveTableEvent(this.inputData);
            }
            else if (response.message == 'select bjl structure n2p') {
              this.showBJLTable = false;
              this.inputData = response;
              this.tableData = response;
              this.select_jl_screen = true;
              this.show_smp_table = false;
              //this.tableChildComponent.initializeFunction(this.inputData);
              this.mapChildComponent.receiveTableEvent(this.inputData);
            }
            else if (response.message == 'select new smp') {
              this.smp_connectivity_flag = true;
              this.select_jl_screen = false;
              this.showBJLTable = false;
              this.tableData = response;
              }
            else {              
              if ('file_name' in response) {
                this.showBJLTable = false;
                this.showMessage = true;
                this.MessageToShow = response;
              } else {
                this.toastr.error(response.message, 'Error Message');
                console.log('error');
              }
            }

            this.isLoading = false;
            this.spinner.hide();
      }
      ,
      error: (error) => {
            this.isLoading = false;
            this.spinner.hide();
            this.toastr.error(
              `The API returned Unsuccessfull response : ${error}`,
              'Error Message'
            );
          },
    });
    }
    this.isLoading = false;
    this.spinner.hide();
  }

  receiveTableEventStructure(data: any) {
    this.mapChildComponent.receiveTableEvent(data,'bjl_smp')
  }

  checkDistance(){
    try{
      this.isLoading = true;
      this.show_distance = false;
      this.spinner.show();
      this.inputData['selected_bjl_val'] = this.inputData.selected_bjl.bjl_id;
      this.inputData['selected_pit_val'] = this.pit_value;
      this.apiService.pitBjlDistancehd(this.inputData).subscribe({
          next: (response) => {
            if (response.message == 'select smp structure') {
                
                //this.upstream_screen = false;
                this.inputData = response;
                this.tableData = response;
                //this.select_smp_screen = true;
                this.show_smp_table = true;
                
                this.show_status = true;
                this.pit_validation = this.inputData.pit_validation;
                if(this.pit_validation.pit_location == undefined || this.pit_validation.pit_location == null ) {
                    this.show_distance = true;
                    //this.tableChildComponent.initializeFunction(this.inputData);
                    //this.mapChildComponent.receiveTableEvent(this.inputData);
                }
                //this.pit_validation.pit_status = false;
                if(this.pit_validation.pit_status == false){
                  this.update_pit = true;
                }
                if(this.pit_validation.pit_status == true){
                  this.update_pit = false;
                }
                //this.mapChildComponent.receiveTableEvent(this.inputData);
            }
            
            else if (response.message == 'select bjl n2p') {
                
                //this.upstream_screen = false;
                this.inputData = response;
                this.tableData = response;
                this.tableChildComponent.initializeFunction(this.inputData);
              }
            else if(response.message == "Pit Fitness Failed"){
              this.update_pit = true;
              this.show_distance = false;
              this.show_status = true;
              this.inputData = response;
              this.pit_validation = this.inputData.pit_validation;
              this.toastr.error(response.message, 'Error Message');
            }
            else {              
                if ('file_name' in response) {
                  
                  this.showMessage = true;
                  this.MessageToShow = response;
                } else {
                  this.toastr.error(response.message, 'Error Message');
                  console.log('error');
                }
              } 

            this.isLoading = false;
            this.spinner.hide();
          },
          error: (error) => {
            this.isLoading = false;
            this.spinner.hide();
            this.toastr.error(
              `The API returned Unsuccessfull response : ${error}`,
              'Error Message'
            );
          },
        });
    }
      catch(e) {
      this.isLoading = false;
            this.spinner.hide();
            this.toastr.error(
              `The API returned Unsuccessfull response : ${e}`,
              'Error Message'
            );
    }
  }
  inputOnChange(event: Event) {
    const input = event.target as HTMLInputElement;
    this.pit_value = input.value
    console.log('Value:', input.value);
  }

  skipLocations(){
    this.isLoading = true;
    this.spinner.show();
    //this.inputData['selected_bjl_val'] = this.inputData.selected_bjl.bjl_id;
    //this.inputData['selected_pit_val'] = this.pit_value;
    this.apiService.skipUnwatedLochd(this.inputData).subscribe({
        next: (response) => {
          if (response.message == 'n2p process completed') {
              //this.map_div = false;
              //this.upstream_screen = false;
              this.inputData = response;
              this.tableData = response;
              //this.select_smp_screen = false;
              this.show_smp_table = false;
              this.show_distance = false;
              this.show_status = false;
              //this.select_bjl = false;
              this.pit_validation = this.inputData.pit_validation;
              //this.final_screen = true;
              //this.tableChildComponent.initializeFunction(this.inputData);
          } else {
            //this.showTable = false;
              this.toastr.error(
              `The API returned Unsuccessfull response`,
              'Error Message'
            );
          }

          this.isLoading = false;
          this.spinner.hide();
        },
        error: (error) => {
          this.isLoading = false;
          this.spinner.hide();
          this.toastr.error(
            `The API returned Unsuccessfull response : ${error}`,
            'Error Message'
          );
        },
      });
  }

  pitSizeOnChange(event: Event) {
    const input = event.target as HTMLInputElement;
    this.pit_size_value = input.value
    console.log('Value:', input.value);
  }

  pitSizeChange(){
    this.isLoading = true;
    this.spinner.show();
    this.inputData['updated_pit_size'] = this.pit_size_value;
    this.inputData['selected_pit_val'] = this.pit_value;
    this.apiService.pitSizeUpdatehd(this.inputData).subscribe({
        next: (response) => {
          if (response.message == 'pit size updated successfully') {              
              this.update_pit = false;
              this.inputData = response;
              this.tableData = response;
              this.mapChildComponent.receiveTableEventPit(this.inputData);
              this.inputData['selected_pit_val'] = '';
              this.inputData['updated_pit_size'] = '';
              this.toastr.success(
              response.message,
              'success Message'
            );
              
          } else if(response.message == "Pit Fitness Failed"){
            this.update_pit = true;
          }else {
            //this.showTable = false;
              this.toastr.error(
              `The API returned Unsuccessfull response`,
              'Error Message'
            );
          }

          this.isLoading = false;
          this.spinner.hide();
        },
        error: (error) => {
          this.isLoading = false;
          this.spinner.hide();
          this.toastr.error(
            `The API returned Unsuccessfull response : ${error}`,
            'Error Message'
          );
        },
      });
  }
onSubmit(){
    this.isLoading = true;
    this.spinner.show();
    this.inputData['a_pit'] = this.a_pit;
    this.inputData['z_pit'] = this.z_pit;
    this.inputData['no_of_pits'] = this.no_of_pits;
    this.apiService.createTrenchN2P(this.inputData).subscribe({
        next: (response) => {
          if (response.message == 'New Pit and Trenches Created') {              
              this.update_pit = true;
              this.trench_creation = false;
              this.inputData = response;
              this.tableData = response;
              this.mapChildComponent.receiveTableEventPit(this.inputData);
              this.toastr.success(
                response.message,
                'success Message'
              );
              
          } else if(response.message == "Process Failed"){
            this.update_pit = false;
            this.trench_creation = true;
            this.toastr.success(
                response.message,
                'Error Message'
              );
          }else {
            //this.showTable = false;
              this.toastr.error(
              `The API returned Unsuccessfull response`,
              'Error Message'
            );
          }

          this.isLoading = false;
          this.spinner.hide();
        },
        error: (error) => {
          this.isLoading = false;
          this.spinner.hide();
          this.toastr.error(
            `The API returned Unsuccessfull response : ${error}`,
            'Error Message'
          );
        },
      });
  }
  updateVal(event: Event,field_type:string){
    const input = event.target as HTMLInputElement;
    if(field_type == 'a_pit'){
        this.a_pit = input.value
    }
    else if(field_type == 'z_pit'){
      this.z_pit = input.value
    }
    else if(field_type == 'no_of_pits'){
      this.no_of_pits = input.value
    }
  }
  
}
